import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmeraldTabBarModule } from '@emerald-angular/tab-bar';
import { EmeraldButtonModule } from '@emerald-angular/button';
import { EmeraldDatatableModule } from '@emerald-angular/datatable';
import { EmeraldIconModule } from '@emerald-angular/icon';
import { EmeraldInputModule } from '@emerald-angular/input';
import { OpenPositionsComponent } from './open-positions/open-positions.component';
import { VendorRepJobDetailsComponent } from './vendor-rep-job-details/vendor-rep-job-details.component';
import { SharedModule } from '@shared/shared.module';
import { CandidatesComponent } from './candidates/candidates.component';
import { EmeraldModalModule } from '@emerald-angular/modal';
import { EmeraldAccordionGroupModule } from '@emerald-angular/accordion-group';
import { OpenPositionFilterComponent } from '@shared/modals/open-position-filter/open-position-filter.component';
import { JobDetailsFilterComponent } from '@shared/modals/job-details-filter/job-details-filter.component';
import { CandidateFilterComponent } from '@shared/modals/candidate-filter/candidate-filter.component';
import { AddCandidateComponent } from './add-candidate/add-candidate.component';
import { AuthGuard } from '@core/okta-auth.guard';
import { CandidateFeedbackComponent } from '@shared/modals/candidate-feedback/candidate-feedback.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EmeraldDropdownModule } from '@emerald-angular/dropdown';
import { EmeraldDatepickerModule } from '@emerald-angular/datepicker';
import { DeleteCandidateComponent } from './delete-candidate/delete-candidate.component';
import { EmeraldTooltipModule } from '@emerald-angular/tooltip';
import { OpenPositionsFlagLegendComponent } from '@shared/components/open-positions-flag-legend/open-positions-flag-legend.component';
import { ModalWrapperComponent } from '@shared/components/modal-wrapper/modal-wrapper.component';
import { MatDialogModule } from '@angular/material/dialog';
const routes: Routes = [
  {
    path: 'vendor',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: OpenPositionsComponent },
      { path: 'job-details', component: VendorRepJobDetailsComponent },
      { path: '**', redirectTo: '', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [
    EmeraldTabBarModule,
    EmeraldButtonModule,
    EmeraldDatatableModule,
    EmeraldIconModule,
    EmeraldInputModule,
    SharedModule,
    RouterModule.forChild(routes),
    EmeraldModalModule,
    EmeraldAccordionGroupModule,
    OpenPositionFilterComponent,
    OpenPositionsFlagLegendComponent,
    JobDetailsFilterComponent,
    CandidateFilterComponent,
    CandidateFeedbackComponent,
    ReactiveFormsModule,
    EmeraldDropdownModule,
    CommonModule,
    ReactiveFormsModule,
    EmeraldDatepickerModule,
    EmeraldTooltipModule,
    ModalWrapperComponent,
    MatDialogModule,
  ],
  declarations: [
    OpenPositionsComponent,
    CandidatesComponent,
    VendorRepJobDetailsComponent,
    AddCandidateComponent,
    DeleteCandidateComponent
  ],
})
export class VendorModule {}
